import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { useSearchParams } from "react-router-dom";
import FailedVerification from "../components/FailedVerification/FailedVerification";
import SuccessfulVerification from "../components/SuccessfulVerification/SuccessfulVerification";
import { isMobile } from "../Utils";
import { APP_LINK_REQUEST_VERIFICATION_EMAIL, BASE_URL, EMAIL_VERIFICATION_ENDPOINT } from "../CONSTANTS"

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    padding: "0",
  },
};

const Axios = axios.create({
  baseURL: BASE_URL,
});
function VerifyEmail() {
  const [isLoading, setIsLoading] = useState(false);
  const [isResendToken, setIsResendToken] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  useEffect(() => {
    async function verifyEmail() {
      setError("");
      setIsLoading(true);
      try {
        const result = await Axios.post(`${EMAIL_VERIFICATION_ENDPOINT}${token}`);
        setData(result.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    }
    if (token) {
      if(isMobile()){
        document.location.href = `${APP_LINK_REQUEST_VERIFICATION_EMAIL}${token}`;
      } else {
        verifyEmail();
      }
    }
  }, [token]);

  const resendToken= () => {
    setIsResendToken(true)
  }
  return (
    <div>
      {isLoading ?
          <div>
            <p>Verifying email..</p>
          </div> :
          isResendToken ?
              <div>
                <p>A new token was sent to your email </p>
              </div> :
            <>
              <ReactModal isOpen={!token || !!error} style={customStyles}>
                <FailedVerification client={Axios} handleClose={resendToken}/>
              </ReactModal>
              <ReactModal isOpen={!error && token && data} style={customStyles}>
                <SuccessfulVerification />
              </ReactModal>
            </>
      }
    </div>
  );
}

export default VerifyEmail;
